import React from 'react'
import PropTypes from 'prop-types'
import { DownloadIcon } from '@heroicons/react/outline'
import Button from '../Button/Button'
import * as XLSX from 'xlsx'
import clsx from 'clsx'
import useScreen from '../../hooks/useScreen'

const ExportDataButton = ({
    text,
    fileName,
    data,
    tittles,
    sheetName,
    className,
    isButtonSmallMD = false,
}) => {
    const { isMobile } = useScreen()
    const handleOnExport = () => {
        let workBook = XLSX.utils.book_new()
        const excelHeader = tittles && tittles[0] && Object.keys(tittles[0])
        let workSheet = XLSX.utils.json_to_sheet(tittles, {
            header: excelHeader,
            skipHeader: true,
            origin: 0,
        })

        XLSX.utils.sheet_add_json(workSheet, data, {
            header: excelHeader,
            skipHeader: true,
            origin: -1, //ok
        })

        XLSX.utils.book_append_sheet(workBook, workSheet, sheetName)

        XLSX.writeFile(workBook, fileName)
    }

    return (
        <div
            className={clsx(
                'flex flex-row items-center jusitfy-center',
                className,
            )}
        >
            <Button
                variant="tertiary"
                text={isButtonSmallMD && isMobile ? '' : text}
                className="text-textDarkGray text-sm md:w-auto h-12 w-full min-w-max"
                icon={
                    <DownloadIcon className="text-black noText md:mr-2 mr-0" />
                }
                onClick={handleOnExport}
            />
        </div>
    )
}

ExportDataButton.propTypes = {
    text: PropTypes.string.isRequired,
    fileName: PropTypes.string.isRequired,
    sheetName: PropTypes.string.isRequired,
    data: PropTypes.arrayOf(PropTypes.object),
    tittles: PropTypes.arrayOf(PropTypes.object),
    className: PropTypes.oneOfType([PropTypes.string, PropTypes.any]),
    isButtonSmallMD: PropTypes.bool,
}

export default ExportDataButton
